<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车位号：</span>
        </div>
        <el-input v-model="formData.lotNumber" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="formData.carNumber" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车主姓名：</span>
        </div>
        <el-input v-model="formData.carOwnerName" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">起始时间：</span>
        </div>
        <el-input v-model="formData.enterStartDate" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">结束时间：</span>
        </div>
        <el-input v-model="formData.enterEndDate" disabled size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!-- <b class="red">*</b> -->
          <span class="line-text">退费金额：</span>
        </div>
        <el-input v-model="reqData.money"  size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">进出截止日期：</span>
        </div>
        <el-date-picker v-model="reqData.refundDate"  type="date"  :default-value="formData.enterStartDate" size="small" :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="width: 280px" placeholder="选择截止日期"></el-date-picker>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退费时间：</span>
        </div>
          <el-date-picker
            style="width:280px"
            value-format="yyyy-MM-dd hh:mm:ss"
            v-model="reqData.payTime"
            type="datetime"
            placeholder="选择收款时间"
            align="right">
          </el-date-picker>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/ParkingService";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "monthly-vehicle-refund",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "包月车辆"
        }
      ],
      mainTitle: "退款时间",
      formData: {
        code: "",
        lotNumber: "",
        enterStartDate: "",
        enterEndDate: "",
        carNumber: ""
      },
      reqData: {
        code: "",
        money: "",
        carNumber: "",
        carOwnerName: "",
        refundDate: ""
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      responsiblePersonList: []
    };
  },
  created() {
    this.formData.code = this.$route.params.id;
    this.reqData.code = this.$route.params.id;
    this.getMonthlyVehicleByCode();
    // this.getResponsiblePersonList();
    // this.remoteMethod();
  },
  methods: {
    toMonthlyVehiclePage() {
      this.$router.push({
        name: "monthly-vehicle"
      });
    },
    getResponsiblePersonList(searchKey) {
      this.$axios
        .post(api.getResponsiblePerson, {
          searchKey: searchKey || ""
        })
        .then(res => {
          let list = res.data.data;
          list.forEach(it => {
            it._value = it.code;
            it._label = it.name;
            this.responsiblePersonList = list;
          });
        })
        .catch(errorHandler("获取经办人数据失败"));
    },
    remoteMethod(query) {
      this.getResponsiblePersonList(query);
    },
    getMonthlyVehicleByCode() {
      this.$axios
        .get(`${api.getMonthlyVehicleByCode}/${this.$route.params.id}`)
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData = res.data.data;
            let endTime = this.formData.enterEndDate;
            let startTime = this.formData.enterStartDate;
            this.pickerOptions = {
              disabledDate(time) {
                return (
                  time.getTime() >= new Date(endTime).getTime() ||
                  time.getTime() <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000 * 2
                );
              }
            };
            this.reqData.carNumber = res.data.data.carNumber;
            this.reqData.carOwnerName = res.data.data.carOwnerName;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    confirm() {
      if (!this.reqData.refundDate) {
        nError("请选择退款日期");
        return false;
      }
      if (!this.reqData.payTime) {
        nError("请选择收款时间");
        return false;
      }
      this.$axios
        .post(api.MonthlyVehicleRefund, this.reqData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("退费成功");
            this.toMonthlyVehiclePage();
          }
        })
        .catch(errorHandler("退费失败"));
    },
    cancel() {
      this.toMonthlyVehiclePage();
    }
  },
  watch: {}
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.form-line > span {
  font-size: 12px;
  color: #97a8be;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
</style>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/MonthlyVehicle/MonthlyVehicleRefund.vue